import { render } from "./TeamResultIntermiadiate.vue?vue&type=template&id=6054e656&scoped=true&ts=true"
import script from "./TeamResultIntermiadiate.vue?vue&type=script&lang=ts"
export * from "./TeamResultIntermiadiate.vue?vue&type=script&lang=ts"

import "./TeamResultIntermiadiate.vue?vue&type=style&index=0&id=6054e656&lang=scss&scoped=true"

import exportComponent from "/Users/nicolacentonze/Desktop/Projects/cons-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6054e656"]])

export default __exports__